<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen';
import BoConfig from '@config/BoConfig';

export default {
  extends: Base,
  data(){
    return {
      Name:"Settings",
      PageName: "Settings List",
      ObjectName: "Settings",
      mrValidation: {
        s_values: "required",
        confidential: "required",
        manulife_withdrawal: "required",
        exit_interview: "required",
        notification: "required",
      },
      isInvalid : 0,
      isClicked : false,

      loadingNotificationLink: true
    }
  },
  computed:{
    mrAccessMenu(){ return BoConfig.mrAccessMenu },
    mrAccessModule(){ return BoConfig.mrAccessModule },
  },
  mounted(){
    this.$set(this.$root, 'page', this)
    this.refreshData()

    setTimeout(() => {     
      this.removeTag()
    }, 700)
  },
  methods:{
    removeTag(){
      if(this.row.s_type == 'notification_link'){
        this.row.s_values.notification = this.removeHtmlTags(
          this.br2nl(this.row.s_values.notification)
        )

        this.$set(this, 'loadingNotificationLink', false)
      }
    },
    setNotificationLink(){
      let notificationLink = this.changeLink2Anchor(this.row.s_values.notification)
      notificationLink = this.nl2br(notificationLink)

      this.$set(this.row.s_values, 'notification', notificationLink)
    },
    nl2br(str) {
      return str.replace(/\n/g, '<br /> ');
    },
    br2nl(str) {
      return str.replace(/<br\s?\/?>/g, '\n');
    },
    removeHtmlTags(str) {
      return str.replace(/<[^>]*>/g, '');
    },
    changeLink2Anchor(text) {
      const regex = /(https?:\/\/[^\s]+)/g;
      const links = text.match(regex);

      let replacedText = text
      links.forEach(link => {
        replacedText = replacedText.replace(link, `<a href="${link}" target="_blank" class="notif-link">${link}</a>`)
      })
      
      return replacedText
    },
    successFormCallback(resp){
      return Gen.info(resp.message, "success", 1000).then(()=>{
        this.refreshVariable()
        this.$router.push({name:this.Name})
      })
    },
    changeValCC(e, k){
      if(this.isClicked){
        let re = /\S+@\S+\.\S+/;
        if(!e){
          this.isInvalid = this.isInvalid + 1
          $("#cc"+k).removeClass("d-none")
          $("#cc"+k).text("Input CC email required.")
        } else if (!re.test(e)) {
          this.isInvalid = this.isInvalid + 1
          $("#cc"+k).removeClass("d-none")
          $("#cc"+k).text("Input the valid email.")
        } else {
          this.isInvalid = 0
          $("#cc"+k).addClass("d-none")
        }
      }
    },
    onSubmitForm(e){
      if(this.row.s_type=='email'){
        let re = /\S+@\S+\.\S+/;
        for(let i = 0; i < (this.row.s_values.cc||[]).length; i++){
          if(!this.row.s_values.cc[i]){
            this.isInvalid = this.isInvalid + 1
            $("#cc"+parseInt(i)).removeClass("d-none")
            $("#cc"+parseInt(i)).text("Input CC email required.")
          } else if (!re.test(this.row.s_values.cc[i])) {
            this.isInvalid = this.isInvalid + 1
            $("#cc"+parseInt(i)).removeClass("d-none")
            $("#cc"+parseInt(i)).text("Input the valid email.")
          } else {
            $("#cc"+parseInt(i)).addClass("d-none")
          }
        }
        this.isClicked = true
        
        setTimeout(()=>{
          this.isInvalid = 0
        },1000)
        
        if(this.isInvalid){
          return
        }
      }

      if(this.row.s_type == 'notification_link'){
        this.setNotificationLink()
      }

      this.submitForm(e)
    }
  },
  watch:{
    '$route.query'(v){
      this.refreshData()
      
      setTimeout(() => {     
        this.removeTag()
      }, 700)
    }
  }
}
</script>

<template>
  <div class="container-fluid">
    <PageTitle></PageTitle>
    
    <!-- ======================================================================== 
      LIST DATA
    ============================================================================= -->
    <div class="card card-flat" v-if="!$route.params.id">
      <div class="card-body card-filter">
        <VForm @resp="search">
          <div class="row">
            <div class="col-sm-3">
              <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
            </div>
            <div class="col-sm-5">
            </div>
            <div class="col-sm-3">
              <div class="has-feedback has-feedback-left">
                <input type="search" v-model="filter.search" class="form-control" placeholder="Type and hit Enter">
                <div class="form-control-feedback">
                  <i class="icon-search4 text-size-base text-muted"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-1">
              <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm">Reset</button>
            </div>
          </div>
        </VForm>
      </div>
      <div class="table-responsive ajax-table">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th width="50px">#</th>
              <th>{{fields.s_name}}</th>
              <th width="120px">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v,k) in data.data" :key="k">
              <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
              <td>{{v.s_name}}</td>
              <td class="btn-action">
                <router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Edit'"><i class="icon-pencil"></i></router-link>
              </td>
            </tr>
            <tr v-if="NotFound">
              <td colspan="99">
                <h3 class="tc">{{NotFound}}</h3>
              </td>
            </tr>
            <tr v-if="data.data===false">
              <td colspan="99">
                <LoadingSpinner light></LoadingSpinner>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body">
        <div class="pull-right">
          <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
        </div>
      </div>
    </div>

    <!-- ======================================================================== 
      FORM CRUD
    ============================================================================= -->
    <div class="card card-flat" v-if="$route.params.id">
      <VForm @resp="onSubmitForm" method="post">
        <div class="card-body card-form">
          <h4 class="card-title">{{(row.id?"Edit":"Add")+" "+ObjectName}}</h4>
        </div>
        <div class="card-body">
          <div class="info"></div>
          <div class="row">
            <div class="col-sm-12">
                <div class="alert alert-info sm" role="alert">
                  <b class="fw-500">Note:</b> {{row.s_note}}
                </div>
            </div>
            <div class="col-sm-6">
              <BoField name="s_name" :value="row.s_name" :disabled="true"></BoField>
              <div v-if="row.s_type=='int'">
                <BoField name="s_values" label="Value" v-model="row.s_values" :attr="{type:'number'}">
                  <small class="help" slot="help">{{row.s_note}}</small>
                </BoField>
              </div>
            </div>

            <template v-if="row.s_type=='offboarding_docs'">
              <div class="col-sm-6">
                <BoField name="confidential">
                  <Uploader name="confidential" path="docs" v-model="row.s_values.confidential" accept="docs" :attr="validation('confidential')"></Uploader>
                </BoField>
                <BoField name="manulife_withdrawal">
                  <Uploader name="manulife_withdrawal" path="docs" v-model="row.s_values.manulife_withdrawal" accept="docs" :attr="validation('manulife_withdrawal')"></Uploader>
                </BoField>
              </div>
              <div class="col-sm-6">
                <BoField name="exit_interview">
                  <Uploader name="exit_interview" path="docs" v-model="row.s_values.exit_interview" accept="docs" :attr="validation('exit_interview')"></Uploader>
                </BoField>
                <BoField name="clearance">
                  <Uploader name="clearance" path="docs" v-model="row.s_values.clearance" accept="docs" :attr="validation('clearance')"></Uploader>
                </BoField>
              </div>
            </template>

            <template v-if="row.s_type=='default_password'">
              <div class="col-sm-6">
                <BoField name="default_password" v-model="row.s_values.default_password" :attr="{required:true, type:'text'}" mandatory></BoField>
              </div>
            </template>

            <template v-if="row.s_type=='lock_authorization'">
              <div class="col-sm-3">
                <BoField name="startdate">
                  <div class="input-group">
                    <DatePicker name="startdate" v-model="row.s_values.startdate" placeholder="Start Date" required></DatePicker>
                    <div class="input-group-append">
                      <span class="input-group-text"><i class="icon-calender"></i></span>
                    </div>
                  </div>
                </BoField>
              </div>
              <div class="col-sm-3">
                <BoField name="enddate">
                  <div class="input-group">
                    <DatePicker name="enddate" v-model="row.s_values.enddate" placeholder="End Date" required></DatePicker>
                    <div class="input-group-append">
                      <span class="input-group-text"><i class="icon-calender"></i></span>
                    </div>
                  </div>
                </BoField>
              </div>
              <div class="col-sm-3">
                <BoField name="lock">
                  <div class="radio-group">
                    <Radio name="status" v-model="row.s_values.lock" :option="true">Active</Radio>
                    <Radio name="status" v-model="row.s_values.lock" :option="false">Inactive</Radio>
                  </div>
                </BoField>
              </div>
            </template>

            <template v-if="row.s_type=='day_reminders'">
              <div class="col-sm-6">
                <BoField label="Reminder in day">
                  <table class="table table-bordered mb0">
                    <tr class="thead-light">
                      <th>Day H(-)?</th>
                      <th></th>
                    </tr>
                    <tr v-for="(v,k) in row.s_values" :key="k">
                      <td>
                        <input type="number" class="form-control" v-model="row.s_values[k]">
                      </td>
                      <td class="btn-action" width="75px">
                        <button type="button" class="btn btn-success icon_action" @click="row.s_values.push(0)" v-tooltip="'Add'"><i class="icon-plus"></i></button>
                        <button type="button" class="btn btn-danger icon_action" @click="row.s_values.splice(k,1)" v-tooltip="'Remove'" :disabled="row.s_values.length<=1"><i class="icon-trash"></i></button>
                      </td>
                    </tr>
                  </table>
                </BoField>
              </div>
            </template>

            <template v-if="row.s_type=='email'">
              <div class="col-sm-3">
                <BoField name="receiver_email" v-model="row.s_values.email" :attr="{required:true, type:'email'}" mandatory></BoField>
                <!--
                <BoField name="email">
                  <input type="email" class="form-control" v-model="row.s_values.email" :attr="validation('email')">
                </BoField>
                -->
              </div>
              <div class="col-sm-6">
                <BoField label="CC Email">
                  <table class="table table-bordered mb0">
                    <tr class="thead-light">
                      <th>CC :</th>
                      <th></th>
                    </tr>
                    <tr v-for="(v,k) in row.s_values.cc" :key="k">
                      <td>
                        <input type="text" class="form-control" @input="changeValCC($event.target.value, k)" v-model="row.s_values.cc[k]">
                        <label :id="'cc'+parseInt(k)" class="error2 text-danger d-none"></label>
                      </td>
                      <td class="btn-action" width="75px">
                        <button type="button" class="btn btn-success icon_action" @click="row.s_values.cc.push('')" v-tooltip="'Add'"><i class="icon-plus"></i></button>
                        <button type="button" class="btn btn-danger icon_action" @click="row.s_values.cc.splice(k,1)" v-tooltip="'Remove'"><i class="icon-trash"></i></button>
                      </td>
                    </tr>
                    <tr v-if="!(row.s_values.cc).length">
                      <td class="text-center">
                        Add New Data
                      </td>
                      <td class="btn-action text-center" width="75px">
                        <button type="button" class="btn btn-success icon_action" @click="row.s_values.cc.push('')" v-tooltip="'Add'"><i class="icon-plus"></i></button>
                      </td>
                    </tr>
                  </table>
                </BoField>
              </div>
            </template>

            <template v-if="row.s_type=='notification_link'">
              <div class="col-md-9">
                <bo-field name="notification" label="Notification Link" mandatory>
                  <textarea name="notification" v-model="row.s_values.notification" id="notification" rows="5" class="form-control"
                  v-bind="validation('notification')" :disabled="loadingNotificationLink"></textarea>
                </bo-field>
              </div>
            </template>

            <div class="col-sm-12">
              <div class="text-right">
                <button type="button" @click="back()" class="btn btn-default mr5">Cancel</button>
                <button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit form <i class="icon-arrow-right14 position-right"></i></button>
              </div>
            </div>
          </div>
        </div>
      </VForm>
    </div>
  </div>
</template>
